import Idle from '../../lib/idle'

import {getState, dispatch} from '../store'
import setCurrentUserActivityStatus from '../actions/set_current_user_activity'

let idle

export const watchCurrentUserActivity = () => {
  const inactivityStartTime = getState().getIn(['chatSettings', 'inactivityStartSeconds']) * 1000

  idle = new Idle({
    onVisible: () => dispatch(setCurrentUserActivityStatus(true)),
    onHidden: () => dispatch(setCurrentUserActivityStatus(false)),
    onAway: () => dispatch(setCurrentUserActivityStatus(false)),
    onAwayBack: () => dispatch(setCurrentUserActivityStatus(true)),
    awayTimeout: inactivityStartTime
  })

  idle.start()
}

export const unwatchCurrentUserActivity = () => {
  if (idle) idle.stop()
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_user_activity.js
 **/